import { FC, useState } from 'react';

import { WidgetCard } from '@/shared/ui';

import { SessionList } from '@/features/manageSessions';

type ActiveSessionsProps = {
  className?: string;
};

export const ActiveSessions: FC<ActiveSessionsProps> = (props) => {
  const { className } = props;

  const [isUnavailable, setIsUnavailable] = useState(false);

  if (isUnavailable) {
    return null;
  }

  return (
    <WidgetCard className={className} data-component="active-sessions">
      <SessionList onUnavailable={() => setIsUnavailable(true)} />
    </WidgetCard>
  );
};
